import * as React from "react";
import { Text } from "react-native";
import { Dimensions } from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
Dimensions.get("screen");
import Login from "../page/login/login";
import Home from "../page/home/home";
import FreePoint from "../page/freepoint/freepoint";
import CreateFreepoint from "../page/freepoint/createfreepoint";
import DisCount from "../page/discount/discount";
import CreateDiscount from "../page/discount/creatediscount";
import Banner from "../page/banner/banner";
import EditBanner from "../page/banner/editbanner";
import Version from "../page/version/report";
import User from "../page/user/user";
import Admins from "../page/user/admins";
import CreateUser from "../page/user/create-user";
import CreateAdmin from "../page/user/create-admin";
import ProflieUser from "../page/user/profileuser";
import ProflieVip from "../page/user/proflievip";
import EventList from "../page/user/EventList";
import Payment from "../page/user/payment";
import AddBonus from "../page/bonus/addbonus";
import AddDeily from "../page/bonus/adddaily";
import HomeEvent from "../page/event/homeevent";
import HomeEventCoupon from "../page/event/homeeventcoupon";
import UserMission from "../page/event/usermission";
import Report from "../page/report/report";
import EditMission from "../page/event/editmission";
import EditRole from "../page/event/editrole";
import UserRole from "../page/event/userrole";
import EditEvent from "../page/event/editevent";
import UserEvent from "../page/event/userevent";
import Week2 from "../page/bonus/week2";
import Week3 from "../page/bonus/week3";
import Week4 from "../page/bonus/week4";
import MapPage from "../page/map/index";
import Eventrank from "../page/rank/eventrank";
import Eventrank_user from "../page/rank_user/eventrank";
import Userrank_user from "../page/rank_user/userrank";
import Userrank from "../page/rank/userrank";
import Lvlist from "../page/LV/lv_list";
import Createlv from "../page/LV/createlv";
import Term from "../page/terms";
import CreateCoupon from "../page/event/createcoupon";

function Route() {
  const routeNameRef = React.useRef();
  const navigationRef = React.useRef();
  const Stack = createStackNavigator();

  function screen() {
    return (
      <Stack.Navigator headerMode="none" initialRouteName={"Home"}>
        {/* <Stack.Screen name="EditMission" component={EditMission} /> */}
        <Stack.Screen name="Login" component={Login} />
        <Stack.Screen name="Home" component={Home} />
        <Stack.Screen name="FreePoint" component={FreePoint} />
        <Stack.Screen name="CreateFreepoint" component={CreateFreepoint} />
        <Stack.Screen name="DisCount" component={DisCount} />
        <Stack.Screen name="CreateDiscount" component={CreateDiscount} />
        <Stack.Screen name="Banner" component={Banner} />
        <Stack.Screen name="EditBanner" component={EditBanner} />
        <Stack.Screen name="User" component={User} />
        <Stack.Screen name="CreateUser" component={CreateUser} />
        <Stack.Screen name="CreateAdmin" component={CreateAdmin} />
        <Stack.Screen name="ProflieUser" component={ProflieUser} />
        <Stack.Screen name="ProflieVip" component={ProflieVip} />
        <Stack.Screen name="Payment" component={Payment} />
        <Stack.Screen name="AddBonus" component={AddBonus} />
        <Stack.Screen name="AddDeily" component={AddDeily} />
        <Stack.Screen name="HomeEvent" component={HomeEvent} />
        <Stack.Screen name="HomeEventCoupon" component={HomeEventCoupon} />
        <Stack.Screen name="CreateCoupon" component={CreateCoupon} />
        <Stack.Screen name="UserMission" component={UserMission} />
        <Stack.Screen name="Report" component={Report} />
        <Stack.Screen name="EditMission" component={EditMission} />
        <Stack.Screen name="EditRole" component={EditRole} />
        <Stack.Screen name="UserRole" component={UserRole} />
        <Stack.Screen name="EditEvent" component={EditEvent} />
        <Stack.Screen name="UserEvent" component={UserEvent} />
        <Stack.Screen name="Week2" component={Week2} />
        <Stack.Screen name="MapView" component={MapPage} />
        <Stack.Screen name="Week3" component={Week3} />
        <Stack.Screen name="Week4" component={Week4} />
        <Stack.Screen name="Eventrank" component={Eventrank} />
        <Stack.Screen name="Eventrank_user" component={Eventrank_user} />
        <Stack.Screen name="Userrank_user" component={Userrank_user} />
        <Stack.Screen name="EventList" component={EventList} />
        <Stack.Screen name="Version" component={Version} />
        <Stack.Screen name="Userrank" component={Userrank} />
        <Stack.Screen name="Lvlist" component={Lvlist} />
        <Stack.Screen name="Createlv" component={Createlv} />
        <Stack.Screen name="Terms" component={Term} />
        <Stack.Screen name="admins" component={Admins} />
        <Stack.Screen name="roles" component={User} />
      </Stack.Navigator>
    );
  }

  const config = {
    screens: {
      Login: "/Login",
      Payment: "/Payment",
      Mission: "/Mission",
      Report: "/Report",
      EditEvent: "/EditEvent",
      UserEvent: "/UserEvent",
      HomeEvent: "/HomeEvent",
      HomeEventCoupon: "/HomeEventCoupon",
      CreateCoupon: "/CreateCoupon",
      Eventrank_user: "/Eventrank_user",
      Userrank_user: "/Userrank_user",
      Version: "/Version",
      EventList: "/EventList",
      EventList2: "/EventList2",
      Terms: "/Terms",
      MapView: "/MapView",
      User: "/User",
      admins: "/admins",
      roles: "/roles",
    },
  };
  const linking = {
    // prefixes: [
    //   "https://www.asianathleticsassociation.com/",
    //   "asianAthleticsAssociation://",
    // ],
    config,
  };

  return (
    <NavigationContainer linking={linking} fallback={<Text>Loading...</Text>}>
      {screen()}
    </NavigationContainer>
  );
}

export default Route;
